import React from 'react';
import { TemplateEditorProvider } from './context/UseTemplateEditorContext';
import TemplateEditor from './TemplateEditor';
import { useLocation } from 'react-router';

export const TemplateEditorPage: React.FC = () => {
  const { pathname } = useLocation();
  const channel = pathname.includes('onsite') ? 'onsite' : 'offsite';

  return (
    <TemplateEditorProvider channel={channel}>
      <TemplateEditor />
    </TemplateEditorProvider>
  );
};

export default TemplateEditorPage;
